import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.approveAbsence.loading;
export const selectErrorMessage = (state: RootState) =>
  state.approveAbsence.error;
export const approveAbsenceResponse = (state: RootState) =>
  state.approveAbsence.approveAbsenceResponse;
